module.exports = __webpack_public_path__ + "static/media/r27.e3a0c8bc.png";